module.exports = __webpack_public_path__ + "static/media/sm.c9e2a43c.svg";